import type { ConnectorAction, InOutType } from '@repositories/subscriptionConnectionRepository/subscriptionConnection.types';
import { nanoid } from 'nanoid';
import { InputParameterModel } from './InputParameterModel';

export class ConnectorActionModel {
  private readonly _dto: ConnectorAction;
  private _inputParameters: InputParameterModel[];
  private _selected: boolean;
  private readonly _id: string;
  private _source: 'none' | string;

  constructor(dto: ConnectorAction) {
    this._dto = dto;
    this._inputParameters = dto.inputParameters?.length
      ? dto.inputParameters.map(param => new InputParameterModel(param))
      : [];
    this._selected = false;
    this._id = nanoid();
    this._source = 'none';
  }

  get originDTO(): ConnectorAction {
    return this._dto;
  }

  get source() {
    return this._source;
  }

  setSource(sourceId: string) {
    this._source = sourceId;
  }

  get id() {
    return this._id;
  }

  get outputSchema() {
    return this._dto.outputSchema || '';
  }

  get description() {
    return this._dto.description || '';
  }

  get inputParameters() {
    return this._inputParameters;
  }

  set inputParameters(value: InputParameterModel[]) {
    this._inputParameters = value;
  }

  get method() {
    return this._dto.method || '';
  }

  get name() {
    return this._dto.name || '';
  }

  get outputType(): InOutType {
    return this._dto.outputType || 'STRING';
  }

  get configName() {
    if (this._selected) return '설정';
    return '';
  }

  get selected() {
    return this._selected;
  }

  selectAction() {
    this._selected = true;
  }
}
